import React, { Component } from 'react'
import { CloseCircleFilled, QuestionCircleOutlined } from '@ant-design/icons'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import {
  Button,
  DatePicker,
  Input,
  MagicInput,
  message,
  Popover,
  Radio,
  Tooltip
} from 'hljd'
import isNil from 'lodash/isNil'
import dayjs from 'dayjs'
import style from './index.module.less'
import { Upload } from '@hlj/hlj-components'
import SelfUpload from './Upload'
import { observer } from 'mobx-react'
import { COUPONS_PATH_A } from '@constant'
import mainStore from '@components/Main/store'
import { LIVE_TYPE, LIVE_TYPE_DESC } from '../../constant'

const FormItem = Form.Item
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 }
  }
}

const specialUploadStyle = {
  borderRadius: '4'
}

/**
 * 直播主题
 */
export const Title = ({ form: { getFieldDecorator } }) => (
  <FormItem label={'直播主题'} {...formItemLayout}>
    {getFieldDecorator('title', {
      rules: [
        {
          required: true,
          min: 12,
          max: 24,
          message: '需要输入12-24个字'
        }
      ]
    })(
      <MagicInput
        style={{ width: 585 }}
        maxLength={24}
        showCount
        countPosition="inner"
        placeholder="介绍直播主题，建议输入12-24字"
      />
    )}
  </FormItem>
)

/**
 * 直播分类
 */
export const Type = ({ form: { getFieldDecorator } }) => (
  <FormItem label={'直播分类'} {...formItemLayout}>
    {getFieldDecorator('newType', {
      rules: [
        {
          required: true,
          message: '请选择类型'
        }
      ]
    })(<Radio.Group options={LIVE_TYPE} />)}
    {LIVE_TYPE_DESC.map((item, index) => (
      <p className={style['type-desc']} key={index}>
        {index + 1}、{item}
      </p>
    ))}
  </FormItem>
)
/**
 * 直播时间
 */
@observer
export class LiveTime extends Component {
  range = (start, end) => {
    const result = []
    for (let i = start; i < end; i++) {
      result.push(i)
    }
    return result
  }

  disabledDateTime = () => {
    return {
      disabledSeconds: () => this.range(1, 60)
    }
  }
  render() {
    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue },
      store: { useLessTime, handleChackDate }
    } = this.props
    return (
      <div>
        <FormItem label={'直播开始时间'} {...formItemLayout}>
          {getFieldDecorator('datePicker', {
            rules: [{ required: true, message: '请选择日期' }]
          })(
            <DatePicker
              style={{ width: 280, marginRight: 15 }}
              disabledDate={current => {
                return (
                  current &&
                  (current <
                    dayjs()
                      .subtract(1, 'days')
                      .endOf('day') ||
                    useLessTime.includes(current.format('YYYY-MM-DD')))
                )
              }}
              onChange={value =>
                handleChackDate(value, getFieldValue, setFieldsValue)
              }
              format="YYYY-MM-DD HH:mm"
              showTime={{
                // defaultValue: dayjs('00:00', 'HH:mm'),
                format: 'HH:mm'
              }}
              getCalendarContainer={triggerNode =>
                mainStore.contentMainDiv.current
              }
            />
          )}
        </FormItem>
      </div>
    )
  }
}

/**
 * 封面图
 */
@observer
export class VideoCover extends Component {
  coverLimit = {
    width: 1080,
    height: 608
  }
  verticalCoverLimit = {
    width: 500,
    height: 750
  }
  // 封面横图、封面竖图 beforeUpload
  handleValidate = (limitObj, file) => {
    const { width: limitWidth, height: limitHeight } = limitObj
    return new Promise((resolve, reject) => {
      Upload.checkSize(file, ({ width, height }) => {
        if (width >= limitWidth && height >= limitHeight) {
          resolve(true)
        } else {
          message.warn(
            `图片宽度需不小于${limitWidth}px，图片高度需不小于${limitHeight}px`
          )
          reject(false)
        }
      })
    })
  }

  render() {
    const {
      image_path,
      handleUploadVideoCover,
      handleDeleteVideoCover,
      handleClipedVideoCover,
      vertical_image_path,
      changeVImage,
      delVImage,
      ClipedVImage
    } = this.props.store
    const { coverLimit, verticalCoverLimit } = this
    return (
      <FormItem key="VideoCover" required label={'封面图'} {...formItemLayout}>
        <div className={style.upload}>
          <Upload
            width={254}
            height={143}
            aspect={coverLimit.width / coverLimit.height}
            style={specialUploadStyle}
            link={image_path}
            onOk={handleUploadVideoCover}
            onDelete={handleDeleteVideoCover}
            autoSizeError
            clipabled
            limitSize={{ height: coverLimit.height, width: coverLimit.width }}
            max_file_size="10mb"
            validate={this.handleValidate.bind(this, coverLimit)}
            onCliped={handleClipedVideoCover(coverLimit)}
            description={
              <div style={{ color: '#666', lineHeight: 1.5 }}>
                <p>上传图片</p>
                <p>{`${coverLimit.width}*${coverLimit.height}px`}</p>
              </div>
            }
            filters={{
              mime_types: [
                {
                  title: 'images files',
                  extensions: 'jpg,gif,png,jpeg,bmp'
                }
              ],
              max_file_size: '10mb',
              prevent_duplicates: true
            }}
          />
          &nbsp;&nbsp;
          <Upload
            width={134}
            height={143}
            aspect={verticalCoverLimit.width / verticalCoverLimit.height}
            style={specialUploadStyle}
            link={vertical_image_path}
            onOk={changeVImage}
            onDelete={delVImage}
            autoSizeError={true}
            clipabled
            limitSize={{
              height: verticalCoverLimit.height,
              width: verticalCoverLimit.width
            }}
            max_file_size="10mb"
            validate={this.handleValidate.bind(this, verticalCoverLimit)}
            onCliped={ClipedVImage(verticalCoverLimit)}
            description={
              <div style={{ color: '#666', lineHeight: 1.5 }}>
                <p>上传封面</p>
                <p>
                  {`${verticalCoverLimit.width}*${verticalCoverLimit.height}px`}
                </p>
              </div>
            }
            filters={{
              mime_types: [
                {
                  title: 'images files',
                  extensions: 'jpg,gif,png,jpeg,bmp'
                }
              ],
              max_file_size: '10mb',
              prevent_duplicates: true
            }}
          />
        </div>

        <div className={style.tipsArea} key="VideoCoverRow">
          <p className={style.tips}>
            1、<span className={style.tipsHeightLight}>封面图</span>
            展示在直播列表页，请突出直播亮点，可参考
            {
              <Popover
                content={
                  <img
                    src="//qnm.hunliji.com/lvgNaPJREmEqRW_cwRwY7Q9NdCUc"
                    width={800}
                  />
                }
                title={
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}
                  >
                    <p>样例</p>
                    <Button>
                      <a
                        href="//qnm.hunliji.com/lvgNaPJREmEqRW_cwRwY7Q9NdCUc"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        查看详情
                      </a>
                    </Button>
                  </div>
                }
                getPopupContainer={triggerNode =>
                  mainStore.contentMainDiv.current
                }
              >
                <span style={{ cursor: 'pointer', color: '#FF801A' }}>
                  样例
                </span>
              </Popover>
            }；
          </p>
          <p className={style.tips}>
            2、图片大小不可大于
            <span className={style.tipsHeightLight}>10M</span>
            ，需
            <span className={style.tipsHeightLight}>
              高清，请勿在封面图添加任何水印、其他平台logo，不可使用纯白图片
            </span>
            以免审核不通过；
          </p>
          <p className={style.tips}>
            3、支持<span className={style.tipsHeightLight}>JPG、PNG、BMP</span>
            等大部分格式。
          </p>
        </div>
      </FormItem>
    )
  }
}

/**
 * 预热视频
 */
@observer
export class Video extends Component {
  render() {
    const {
      videoInfo: { origin_path },
      verticalVideoInfo: { vertical_origin_path },
      handleUploadVideo,
      handleDeleteVideo
    } = this.props.store
    const { getFieldDecorator } = this.props.form
    return (
      <>
        <FormItem key="Video" label={'预热视频'} {...formItemLayout}>
          <div>
            {/* 横向视频 */}
            {!origin_path ? (
              <div className={style.upload} style={{ display: 'inline-block' }}>
                <Upload
                  width={254}
                  height={143}
                  style={specialUploadStyle}
                  link={origin_path}
                  onOk={(file, link, { persistent_id, avinfo }) =>
                    handleUploadVideo(
                      file,
                      link,
                      { persistent_id, avinfo },
                      'horizontal'
                    )
                  }
                  max_file_size="1024mb"
                  uptoken_url="/p/wedding/home/APIUtils/video_upload_token?from=LivingPreheatVideo"
                  description={
                    <div style={{ color: '#666', lineHeight: 1.5 }}>
                      <p>添加横图视频</p>
                    </div>
                  }
                  filters={{
                    mime_types: [
                      {
                        title: 'video files',
                        extensions: 'avi,mp4,rmvb,wmv,mpg,mov,flv,mkv,mpeg,m4v'
                      }
                    ],
                    max_file_size: '1024mb',
                    prevent_duplicates: true
                  }}
                />
              </div>
            ) : (
              <div style={{ display: 'inline-block' }}>
                <video
                  controls
                  src={origin_path}
                  style={{
                    width: 254,
                    height: 143,
                    background: '#aaa',
                    marginRight: 16
                  }}
                />
                <a
                  href="javascript:void(0);"
                  onClick={() => handleDeleteVideo('horizontal')}
                >
                  删除
                </a>
              </div>
            )}
            {/* 纵向视频 */}
            &nbsp;&nbsp;
            {!vertical_origin_path ? (
              <div className={style.upload} style={{ display: 'inline-block' }}>
                <Upload
                  width={134}
                  height={143}
                  style={specialUploadStyle}
                  link={vertical_origin_path}
                  onOk={(file, link, { persistent_id, avinfo }) =>
                    handleUploadVideo(
                      file,
                      link,
                      { persistent_id, avinfo },
                      'longitudinal'
                    )
                  }
                  max_file_size="1024mb"
                  uptoken_url="/p/wedding/home/APIUtils/video_upload_token?from=LivingPreheatVerticalVideo"
                  description={
                    <div style={{ color: '#666', lineHeight: 1.5 }}>
                      <p>添加竖图视频</p>
                    </div>
                  }
                  filters={{
                    mime_types: [
                      {
                        title: 'video files',
                        extensions: 'avi,mp4,rmvb,wmv,mpg,mov,flv,mkv,mpeg,m4v'
                      }
                    ],
                    max_file_size: '1024mb',
                    prevent_duplicates: true
                  }}
                />
              </div>
            ) : (
              <div style={{ display: 'inline-block' }}>
                <video
                  controls
                  src={vertical_origin_path}
                  style={{
                    width: 134,
                    height: 143,
                    background: '#aaa',
                    marginRight: 16
                  }}
                />
                <a
                  href="javascript:void(0);"
                  onClick={() => handleDeleteVideo('longitudinal')}
                >
                  删除
                </a>
              </div>
            )}
          </div>

          <div className={style.tipsArea} key="VideoRow">
            <p className={style.tips}>
              1、横图宽高比建议为16：9，竖图宽高比建议为2：3，支持
              <span className={style.tipsHeightLight}>
                RMVB、AVI、MP4
              </span>等大部分主流视频格式，
              <a
                href="https://www.yuque.com/zhiboxiaozhushou/tihy4t/pk3nem"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#FF801A' }}
              >
                请点击这里查看样例
              </a>；
            </p>
            <p className={style.tips}>
              2、视频大小
              <span className={style.tipsHeightLight}>
                不能超过1024M，限制在15秒
              </span>
              ；
            </p>
            <p className={style.tips}>
              3、
              <span className={style.tipsWarning}>
                建议设置品牌宣传或者拍摄花絮视频，提高宣传效果
              </span>。
            </p>
          </div>
        </FormItem>
        <FormItem
          label={'推广图'}
          {...formItemLayout}
          extra={
            <div className={style.tipsArea} key="VideoRow">
              <p className={style.tips}>
                1、推广图在直播开始后有机会被抓取到资源位，可参考
                {
                  <Popover
                    content={
                      <img
                        src="//qnm.hunliji.com/o_1djqjcoarpi3imp1q3kf7i1su99.jpg"
                        width={800}
                      />
                    }
                    title={
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between'
                        }}
                      >
                        <p>样例</p>
                        <Button>
                          <a
                            href="//qnm.hunliji.com/o_1djqjcoarpi3imp1q3kf7i1su99.jpg"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            查看详情
                          </a>
                        </Button>
                      </div>
                    }
                    getPopupContainer={triggerNode =>
                      mainStore.contentMainDiv.current
                    }
                  >
                    <span style={{ cursor: 'pointer', color: '#FF801A' }}>
                      样例
                    </span>
                  </Popover>
                }；
              </p>
              <p className={style.tips}>
                2、推广图可加入活动营销文案，图片大小不可大于<span
                  className={style.tipsHeightLight}
                >
                  10M
                </span>，需
                <span className={style.tipsHeightLight}>
                  高清，请勿添加大面积水印、边缘不可白底
                </span>
                ；
              </p>
              <p className={style.tips}>3、支持JPG、PNG、BMP等大部分格式。</p>
            </div>
          }
        >
          {getFieldDecorator('extensionBanner', {
            initialValue: ''
          })(<SelfUpload limitSize={{ height: 432, width: 1080 }} isBanner />)}
        </FormItem>
      </>
    )
  }
}
/**
 * 关联套餐
 */
@observer
export class Packages extends Component {
  render() {
    const {
      showPackageModal,
      packageList,
      deleteRecommendItem
    } = this.props.store

    const savedList = packageList.filter(p => p.checked)
    return (
      <FormItem key="packages" required label={'关联套餐'} {...formItemLayout}>
        {savedList.length < 8 && (
          <Button
            type="primary"
            className={style.packagesAddBox}
            onClick={showPackageModal}
          >
            添加套餐
          </Button>
        )}
        <div className={style.packages}>
          {savedList.map((item, i) => (
            <RecommendCard
              key={i}
              deleteRecommendItem={deleteRecommendItem}
              card={item}
            />
          ))}
        </div>

        <div className={style.tipsArea}>
          <p className={style.tips}>
            建议填写活动力度大的主推套餐（1-8个）。建议设置套餐活动价，例：目前售价5999，直播活动价4999，
          </p>
          <p className={style.tips}>
            需在店铺设置<span className={style.tipsHeightLight}>
              满5999减1000的优惠券
            </span>，直播间会默认关联优惠券，设置优惠券请点击
            <a onClick={() => window.open(`${COUPONS_PATH_A}/detail`)}>这里</a>
          </p>
        </div>
      </FormItem>
    )
  }
}

// 案例
export const Case = observer(({ store }) => {
  const { showCaseModal, caseList, deleteCaseItem } = store

  const savedList = caseList.filter(c => c.checked)
  return (
    <FormItem key="cases" required label={'关联案例'} {...formItemLayout}>
      <div className={style.packages}>
        {savedList.map((item, i) => (
          <RecommendCard
            key={i}
            isHidePrice={true}
            deleteRecommendItem={deleteCaseItem}
            card={item}
          />
        ))}
      </div>
      {savedList.length < 8 && (
        <div className={style.packagesAddBox} onClick={showCaseModal}>
          <div className={style.icon}>
            <div style={{ fontSize: 50, textAlign: 'center' }}>+</div>
            <div style={{ lineHeight: '24px', color: '#666' }}>添加案例</div>
          </div>
        </div>
      )}
      <div className={style.tipsArea}>
        <p className={style.tips}>建议填写主推案例（1-8个）</p>
      </div>
    </FormItem>
  )
})

const RecommendCard = ({ card, isHidePrice, deleteRecommendItem }) => {
  const { cover_path, title, activity_price, actual_price, id } = card
  console.log('activity_price, price', activity_price)
  return (
    <div className={style.packagesItem}>
      <img className={style.itemImg} src={`${cover_path}?imageView2/2/w/122`} />
      <div className={style.itemContent}>
        <p className={style.itemText}>{title}</p>
        {!isHidePrice && (
          <div>
            <p className={style.itemText}>现价：{actual_price}元</p>
            <p className={style.itemText}>
              活动价：{!isNil(activity_price)
                ? `${Number(activity_price).toFixed(2)}元`
                : ''}
            </p>
          </div>
        )}
      </div>
      <div className={style.itemIcon} onClick={() => deleteRecommendItem(id)}>
        <CloseCircleFilled />
      </div>
    </div>
  )
}

/**
 * 直播看点
 */
export const LivePoint = observer(({ store }) => {
  const { watching_focus, handleUploadWatching, handleDeleteWatching } = store
  return [
    <FormItem key="VideoCover" required label={'直播看点'} {...formItemLayout}>
      {watching_focus.map((item, index) => (
        <div key={index} className={style.uploadBox}>
          <Uploader
            link={item.photo.cover_path}
            onDelete={handleDeleteWatching}
            onOk={handleUploadWatching}
          />
        </div>
      ))}
      {watching_focus.length < 10 && (
        <div className={style.uploadBox}>
          <Uploader
            onOk={handleUploadWatching}
            onDelete={handleDeleteWatching}
          />
        </div>
      )}
      <div className={style.tipsArea}>
        <p className={style.tips}>
          建议上传与直播营销相关的图片（1-10张）图片限制宽度在1080px以上，大小不可超过10M，支持JPG、PNG和BMP等大部分格式。可参考
          {
            <Popover
              content={
                <img
                  src="https://qnm.hunliji.com/o_1david4621gl01bqvgaagcl1b1ms.jpg"
                  width={600}
                />
              }
              title="样例"
              placement="top"
              getPopupContainer={triggerNode =>
                mainStore.contentMainDiv.current
              }
            >
              <span style={{ cursor: 'pointer', color: '#FF801A' }}>样例</span>
            </Popover>
          }。
        </p>
      </div>
    </FormItem>
  ]
})

const Uploader = props => {
  return (
    <Upload
      width={254}
      height={143}
      aspect={16 / 9}
      style={specialUploadStyle}
      autoSizeError={true}
      max_file_size="10mb"
      multiple
      description={
        <div style={{ color: '#666', lineHeight: 1.5 }}>
          <p>上传图片</p>
        </div>
      }
      filters={{
        mime_types: [
          {
            title: 'images files',
            extensions: 'jpg,gif,png,jpeg,bmp'
          }
        ],
        max_file_size: '10mb'
      }}
      {...props}
    />
  )
}

/**
 * 预约礼
 */
@observer
export class GiftOfReservation extends Component {
  render() {
    const {
      form: { getFieldDecorator },
      store: { tips }
    } = this.props

    return (
      <FormItem key="appointment_content" label={'预约礼'} {...formItemLayout}>
        {getFieldDecorator('appointment_content', {
          rules: [
            {
              max: 50,
              message: '输入内容超出限制范围'
            },
            {
              required: true,
              message: '请输入预约礼'
            }
          ]
        })(
          <MagicInput.TextArea
            rows={6}
            style={{ width: 585 }}
            showCount
            countPosition="inner"
            maxLength={50}
          />
        )}

        <div
          key="giftOfReservationRow"
          className={style.tipsArea}
          style={{ marginTop: 10 }}
        >
          <p className={style.tips}>{tips.appointment_content}</p>
        </div>
      </FormItem>
    )
  }
}
/**
 * 直播抽奖
 */
@observer
export class OtherActivity extends Component {
  render() {
    const {
      form: { getFieldDecorator },
      store: { tips }
    } = this.props
    return [
      <FormItem key="other_gift_content" label={'直播抽奖'} {...formItemLayout}>
        {getFieldDecorator('other_gift_content', {
          rules: [
            {
              max: 50,
              message: '输入内容超出限制范围'
            }
          ]
        })(
          <MagicInput.TextArea
            rows={6}
            style={{ width: 585 }}
            showCount
            countPosition="inner"
            maxLength={50}
          />
        )}

        <div
          className={style.tipsArea}
          key="otherActivityRow"
          style={{ marginTop: 10 }}
        >
          {tips.other_gift_content.split('；').map((el, i) => (
            <p key={i} className={style.tips}>
              {el}
            </p>
          ))}
        </div>
      </FormItem>
    ]
  }
}

/**
 * 关注礼
 */
@observer
export class GiftOfAttention extends Component {
  render() {
    const {
      form: { getFieldDecorator },
      store: { tips }
    } = this.props

    return (
      <FormItem key="gift_of_attention" label={'关注礼'} {...formItemLayout}>
        {getFieldDecorator('gift_of_attention', {
          rules: [
            {
              max: 20,
              message: '输入内容超出限制范围'
            }
          ]
        })(
          <MagicInput.TextArea
            rows={6}
            style={{ width: 585 }}
            showCount
            countPosition="inner"
            maxLength={20}
          />
        )}

        <div
          key="giftOfReservationRow"
          className={style.tipsArea}
          style={{ marginTop: 10 }}
        >
          <p className={style.tips}>{tips.gift_of_attention}</p>
        </div>
      </FormItem>
    )
  }
}
/**
 * 对接人信息
 */
export const ContactInformation = ({ form: { getFieldDecorator } }) => (
  <div className={style.inputGroup}>
    <FormItem
      label={
        <span>
          对接人信息&nbsp;
          <Tooltip title="对接人信息用于婚礼纪负责直播业务的同事联系您，帮您安排直播细节问题">
            <QuestionCircleOutlined />
          </Tooltip>
        </span>
      }
    >
      {getFieldDecorator('docking_name', {
        rules: [{ required: true, message: '请输入姓名' }]
      })(<Input style={{ width: 200, marginRight: 15 }} placeholder="姓名" />)}
    </FormItem>
    <FormItem label={''}>
      {getFieldDecorator('docking_tel', {
        rules: [
          {
            required: true,
            pattern: /^0?1[3|4|5|6|7|8][0-9]\d{8}$/,
            message: '手机号码格式不正确'
          }
        ]
      })(<Input style={{ width: 300 }} placeholder="手机号码" />)}
    </FormItem>
  </div>
)
